import { getAcceptLanguage } from '@repo/utils';
import { AxiosInstance } from 'axios';
import i18n from 'i18next';

import { handleFailToast } from '../utils/errorHandler';
import { getIdTokenPromise } from '../utils/tokenHelper';

const applyRequestInterceptor = (
  instance: AxiosInstance,
  config: Record<string, any>,
  auth: any,
  cookieDomain: string
) => {
  instance.interceptors.request.use(
    async (reqConfig) => {
      const acceptLanguage = getAcceptLanguage(i18n.resolvedLanguage ?? i18n.language);
      if (acceptLanguage) reqConfig.headers.set('Accept-Language', acceptLanguage);

      const isCustomLogin = localStorage.getItem('isCustomLogin') === 'true';

      if (!isCustomLogin) {
        Object.assign(reqConfig, config, { useToken: false });
        return reqConfig;
      }

      if (config.useLoading) {
        // setLoading(true);
      }
      if (config.useToken) {
        const idToken = await getIdTokenPromise({ auth, axiosInstance: instance, cookieDomain });

        reqConfig.headers.set('Authorization', `Bearer ${idToken}`);
        reqConfig.headers.set('X-Bubbletap-Context', crypto.randomUUID());
        reqConfig.headers.set('X-Bubbletap-Device', auth?.currentUser?.uid ?? '');
        // 요청별 config에서 X-Bubbletap-Platform이 'DMM' / 'FANZA'로 명시 설정된 경우 보존
        const currentPlatform = reqConfig.headers.get('X-Bubbletap-Platform');
        if (currentPlatform !== 'DMM' && currentPlatform !== 'FANZA') {
          reqConfig.headers.set('X-Bubbletap-Platform', 'web');
        }
        reqConfig.headers.set('X-Bubbletap-Store', 'web');
      }

      return reqConfig;
    },
    (error) => {
      handleFailToast('error');
      return Promise.reject(error);
    }
  );
};

export { applyRequestInterceptor };
